import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "../icons/search-icon.svg";
import Image from "../../common/Image";

interface SearchCandidateProps {
  label: string;
  placeholder: string;
  value: string;
  onChangeName: (val: string) => void;
  searchData: any[];
  onSelect: (item: any) => void;
  customClass?: string;
}

const SearchCandidate = ({
  label,
  placeholder,
  value,
  onChangeName,
  searchData,
  onSelect,
  customClass = "",
}: SearchCandidateProps) => {
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setDropDownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  return (
    <div className={`select-wrapper ${customClass}`} ref={wrapperRef}>
      <div className="form-group">
        <label className="form-label">{label}</label>
        <div className="field-wrapper">
          <div className="search-icon">
            <img src={SearchIcon} alt="icon" />
          </div>
          <input
            type="text"
            className="form-control"
            placeholder={placeholder}
            onFocus={() => setDropDownOpen(true)}
            onChange={(e) => onChangeName(e.target.value)}
            value={value}
          />
        </div>
      </div>

      {dropDownOpen && (
        <div className="dropdown-wrapper">
          <div className="dropdown-list-wrapper">
            {searchData?.length > 0
              ? searchData.map((item, index) => (
                  <div
                    className="option-wrapper"
                    key={index}
                    onClick={() => {
                      onSelect(item);
                      setDropDownOpen(false);
                    }}
                  >
                    <div className="icon">
                      <Image src={item.profile_image} alt="icon" />
                    </div>
                    <span>{`${item.first_name} ${item.last_name}`}</span>
                  </div>
                ))
              : "No candidates found"}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchCandidate;
//
